import { Layout, Typography } from 'antd';
import React from 'react';
const { Footer } = Layout;
const { Text } = Typography;

const PageFooter = () => {
  return (
    <Footer className="footer">
      <Text className="footer-text">
        © Bosch Limited {new Date().getFullYear()}, all rights reserved{' '}
      </Text>
      <ul className="list-no-bullet">
        <li>
          <a
            href="/documents/ridebuddy-imprint.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="list-item"
            aria-label="Imprint PDF (opens in new tab)"
          >
            Imprint
          </a>
        </li>
        <li>
          <a
            href="/documents/ridebuddy-legal_information.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="list-item"
            aria-label="Legal information PDF (opens in new tab)"
          >
            Legal information
          </a>
        </li>
        <li>
          <a
            href="/documents/ridebuddy-dpn.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="list-item"
            aria-label="Data privacy PDF (opens in new tab)"
          >
            Data privacy
          </a>
        </li>
        <li>
          <a
            href="/documents/ridebuddy-disclosure_documents.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="list-item"
            aria-label="Disclosure documents PDF (opens in new tab)"
          >
            Disclosure documents
          </a>
        </li>
      </ul>
    </Footer>
  );
};

export default React.memo(PageFooter);
